// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bprmnxqblscngqmrbjfz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJwcm1ueHFibHNjbmdxbXJiamZ6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM1NTg0NzQsImV4cCI6MjA3OTEzNDQ3NH0.t_xg4KdLLEbqUuocyHull0cSUA4VLNcsi5vmlTVnDcc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});